export default __webpack_public_path__ + "static/media/skirmishers_spell_glaive.c43ee1fc.jpg";